<template>
  <div class="userWrap1">
    <div class="cardLoginList1">
      <ul id="uList">
        <li v-for="item in docslist" :key="item.id">
          <div class="ruWrap1" @click="ToMeiTuan(item)">
            <img src="./../../assets/img/images/imgT.jpg" class="L imgT" />
            <div class="ruTop" style="width:100%">
              <h3>{{item.cardname}}</h3>
              <p>点击使用</p>
            </div>
          </div>
        </li>
      </ul>
      <div class="center_box_list090" v-if="docslist.length == 0">{{tip}}</div>
      <div class="bottomheight"></div>
    </div>
    <div class="bottom">
      <!-- <div class="item2" @click="cardLogin">
        <p>快速进入</p>
      </div> -->
      <div class="item1" @click="cardBind" style="width:100%;">
        <p>绑定新卡</p>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '@/api'
import JmmToast from '@/components/JmmToast'
import md5 from 'blueimp-md5'
export default {
  name: 'userWrap',
  data() {
    return {
      token: '',
      sign: '',
      docslist: '',
      unionid: '',
      tip: '', // 无卡提示
      openid: '',
      userid: '',
      mobile: "",
      cardtypes: '', // 美团参数
      cardrights: '', // 美团参数
      appid: "wxc528cd4698883637",
      MT_appid: 'wxfb731459c16602bc', // 美团正式环境使用的 appid
      // MT_appid: 'wx3bcbfead9e8d1a46',    // 美团测试环境使用的 appid
      sign: null, // 签名
      return_uri: '', // 绑定成功后跳转 地址
      scanlinks: '', // 二维码地址
      channel: '', // 判断渠道ID
      merchantId: '',
      stateId: ''
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    this.stateId = this.$route.query.state;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else if(null != this.stateId && undefined != this.stateId && "merchantId" != this.stateId){
      this.merchantId = this.stateId;
      localStorage.setItem('cityMerchantId', this.merchantId);
    } else {
      localStorage.setItem('cityMerchantId', "");
    }
    localStorage.setItem('backUrl', window.location.href.split("return_uri=")[1]);
    this.cardrights = this.$route.query.cardrights;
    this.cardtypes = this.$route.query.cardtypes;
    this.token = this.$route.query.token;
    this.return_uri = this.$route.query.return_uri;
    this.scanlinks = this.$route.query.scanlinks;
    if (null == this.scanlinks || undefined == this.scanlinks) {
      this.scanlinks = '';
    }
    //判断渠道ID
    this.channel = this.$route.query.channel;
    if (null == this.channel || undefined == this.channel) {
      this.channel = '';
    }
  },
  components: {
    JmmToast
  },
  mounted() {
    this.getCode()
  },
  methods: {
    getCode() { // 1 非静默授权，第一次有弹框
      this.code = ''
      var local = window.location.href // 获取页面url
      if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
        // 获取授权后的code位置
        var codeBeg = local.indexOf("?code=");
        var codeEnd = local.indexOf("#/?");
        // 截取授权后的code数据
        var codeCut = local.substring(codeBeg, codeEnd);
        local = local.replace(codeCut, "");
      }      
      var appid = this.channel == '' ? this.appid : this.appid
      this.code = this.getUrlCode().code // 截取code
      if (this.code == null || this.code === '' || this.code == undefined) { // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=${this.merchantId}#wechat_redirect`
      } else {
        var merchantIdState = this.getUrlCode().state // 截取state
        if(null == merchantIdState || undefined == merchantIdState){
          merchantIdState = '';
        }
        if('' == this.merchantId && '' != merchantIdState){
          this.merchantId = merchantIdState;
          localStorage.setItem('cityMerchantId', this.merchantId);
        }
        // 通过code获取信息 
        this.fetch(this.code)
      }
    },
    getUrlCode() { // 截取url中的code方法
      var url = location.search
      this.winUrl = url
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.substr(1)
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = (strs[i].split("=")[1])
        }
      }
      return theRequest
    },

    //  code 登录
    async fetch(codeNum) {
      try {
        // let testToken = '123'
        let testToken = 'jjcimpilpgejfeehkdinjlbgabbgchhe'
        let MT_token = 'jhefijjnecechlkmbiodlfbpjdcpnplc'
        let canToken = this.channel == '' ? testToken : MT_token
        let info = { "appId": this.channel == '' ? this.appid : this.appid, "wxcode": codeNum }
        localStorage.setItem('reToken', canToken)
        let that = this
        const res = await api.user.webLogin(info)
        if (res.code == "000000") {
          that.sign = res.data.sign
          if (res.data.mobile) {
            that.userid = res.data.userid
            that.openid = res.data.openid
            that.sign = res.data.sign
            that.unionid = res.data.unionid
            that.mobile = res.data.mobile
            if (that.channel == '') {
              if (that.return_uri.indexOf("?") != -1) {
                let Bank_url = that.return_uri + `&userid=${res.data.userid}&openid=${res.data.openid}&sign=${res.data.sign}&unionid=${res.data.unionid}&phone=${res.data.mobile}&sign1=${md5('abc' + res.data.sign + 'def')}`
                if (that.scanlinks != '') {
                  Bank_url = Bank_url + `&scanlinks=${that.scanlinks}`
                }
                window.location.href = Bank_url
              } else {
                let Bank_url = that.return_uri + `?userid=${res.data.userid}&openid=${res.data.openid}&sign=${res.data.sign}&unionid=${res.data.unionid}&phone=${res.data.mobile}&sign1=${md5('abc' + res.data.sign + 'def')}`
                if (that.scanlinks != '') {
                  Bank_url = Bank_url + `&scanlinks=${that.scanlinks}`
                }
                window.location.href = Bank_url
              }
            } else {
              that.getList()
            }
          } else {
            let toLogin = `activitycardloginList.html#/?sign=${res.data.sign}&unionid=${res.data.unionid}&mobile=${res.data.mobile}&cardtypes=${that.cardtypes}&return_uri=${that.return_uri}&cardrights=${that.cardrights}&token=${that.token}&openid=${res.data.openid}&userid=${res.data.userid}&channel=${this.channel}&scanlinks=${that.scanlinks}`
            window.location.href = toLogin
          }
        } else {
          if (res.code == '40163' || res.code == '40029') {
            var local = window.location.href // 获取页面url
            if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
              // 获取授权后的code位置
              var codeBeg = local.indexOf("?code=");
              var codeEnd = local.indexOf("#/?");
              // 截取授权后的code数据
              var codeCut = local.substring(codeBeg, codeEnd);
              local = local.replace(codeCut, "");
            }
            // 重新访问 此路径地址
            window.location.href = local;
          }
          // if (res.code == '40163') {
          //   // 重新访问 此路径地址
          //   let toUrl = `activitycardlogin.html#/?return_uri=${decodeURIComponent(localStorage.getItem('backUrl'))}`
          //   window.location.href = toUrl
          //   // this.$forceUpdate()
          // } else {
          //   JmmToast(res.message)
          // }
        }
      } catch (err) {
        //JmmToast(err);
        console.log(err)
      }
    },
    // 点击登录
    async getList() {
      try {
        let testToken = 'jhefijjnecechlkmbiodlfbpjdcpnplc'
        localStorage.setItem('reToken', testToken)

        let info = {
          sign: this.sign,
          cardTypes: this.cardtypes,
          cardRights: this.cardrights,
          index: 1,
          channel: this.channel
        }
        const res = await api.user.mtCardLogin(info)
        if (res.code == '000000') {
          this.docslist = res.data
          document.title = '卡登录'
          if (this.docslist.length == 0) {
            this.tip = '请您绑定卡后再进入该业务平台~'
          }
          // if (this.docslist.length <= 0  ) {
          //   let url = `${this.return_uri}/?ucenter_user_id=${this.userid}&unionid=${this.unionid}&mobile=${this.mobile}&nickname=
          // ${this.nickname}&login_cardtype=0&token=${testToken}&openid=${this.openid}&sign1=${md5('abc' + this.sign + 'def')}`
          //   window.location.href = url
          // }
        } else {
          JmmToast(res.message)
        }
      } catch (err) {
        console.log(err)
      }
    },
    ToMeiTuan(item) {
      //点击状态0=可点击1=不可点击
      let clickstatus = item.clickstatus;
      //飞象-会工生活城市账户判断
      if("GHDFfeixiang" == this.channel && "1" == clickstatus){
        JmmToast("系统升级，请稍后再试，感谢您的支持，谢谢！");
        return;
      }
      var testToken = 'jhefijjnecechlkmbiodlfbpjdcpnplc'
      // let obj = {
      //   ucenter_user_id: item.userId ? item.userId : '',
      //   unionid: this.unionid ? this.unionid : '',
      //   mobile: this.mobile ? this.mobile : '',
      //   nickname: item.nickname ? item.nickname : '',
      //   login_cardtype: item.cardtype ? item.cardtype : 0,
      //   openid: this.openid ? this.openid : ''
      // }

      // !str.includes('21001')
      // 用户唯一标识：ucenter_user_id（必传）
      // 微信unionid： unionid（必传）
      // 用户手机号：  mobile（必传）
      // 用户昵称：nickname （可选。有的话，最好传一下）
      // 登陆卡包的类型：login_cardtype（必传。如果用户没有登陆卡，那这个参数传0即可）

      let url = `${this.return_uri}/?ucenter_user_id=${this.userid}&unionid=${this.unionid}&mobile=${this.mobile}&nickname=
      ${item.nickname}&login_cardtype=${item.cardtype}&token=${testToken}&channel=${this.channel}&openid=${this.openid}&sign1=${md5('abc' + this.sign + 'def')}`
      //   let url = `${this.return_uri}/?ucenter_user_id=${obj.ucenter_user_id}&unionid=${obj.unionid}&mobile=${obj.mobile}&nickname=
      // ${obj.nickname}&login_cardtype=${obj.login_cardtype}&token=${testToken}&channel=${this.channel}&openid=${obj.openid}&sign1=${md5('abc' + this.sign + 'def')}`

      window.location.href = url

    },
    // cardLogin () {
    //   window.location.href = `${this.return_uri}`
    // },
    cardBind: function() {
      let testToken = 'jhefijjnecechlkmbiodlfbpjdcpnplc'
      let toUrl = `activitycardBind.html#/?merchantId=${this.merchantId}&sign=${this.sign}&token=${testToken}&channel=${this.channel}&cardrights=${this.cardrights}&return_url=${this.return_uri}&cardtypes=${this.cardtypes}`
      window.location.href = toUrl
    }
  }
}

</script>
<style lang="stylus">
  @import '../../assets/css/common.styl'
  @import '../../assets/css/icon.css'
  @import '../../assets/css/stylesheet.css'
  .userWrap1
    width 100%
    height 100%
    overflow auto
    background #f5f5f5
  .cardLoginList1
    width calc(100% - 40px)
    margin 20px auto
  .cardLoginList1 li
    width 100%
    height 205px
    background url('../../assets/img/images/bgCard.png') no-repeat center center
    background-size cover
    margin 20px 0
    color #fff
    border-radius 15px
  .ruWrap1
    width calc(100% - 40px)
    margin 0 auto
  .ruWrap1 img
    width 100px
    height 100px
  .poWrap
    width calc(100% - 60px)
    margin 70px auto 0
    height auto
  .poWrap span
    border 1px solid #ff799e
    background #ff799e
    display inline-block
    margin-left 10px
    padding 0px 5px
    border-radius 5%
  .poWrap em
    font-size 33px
  .L
    float left
  .R
    float right
    font-size 28px
    line-height 53px
    height 33px
  .ruTop
    padding-top 50px
  .ruTop h3
    font-size 34px
  .ruTop p
    font-size 28px
  .imgT
    margin 40px 20px 0 20px
  i
    vertical-align middle
    font-size 18px
  .bottom
    position fixed
    bottom 0px
    background-color #fff
    width 100%
    height 80px
    text-align center
  .item1
    width 50%
    background #ff1734
    float left
  .item1 p
    margin 0
    font-size 28px
    color #fff
    line-height 80px
  .item2
    width 50%
    background #999999
    float left
  .item2 p
    margin 0
    font-size 28px
    color #fff
    line-height 80px
  .bottomheight
    height 100px
  .center_box_list090 {
    font-size: 28px;
    font-family: Source Han Sans SC VF;
    text-align: center;
    border-radius: 20px;
    width: 80%;
    height: 350px;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/activitycardlogin/index.vue